import { DataTable } from "primereact/datatable";
import { formatDateYYYYMMDD } from "../../../algorithms/date";
import { Dropdown } from "primereact/dropdown";

const NewDataTable = ({
  children,
  items,
  emptyMessage,
  parentClassName,
  tableClassName,
  headerColumnGroup,
  className,
  footer,
  exportFilename = "mbox",
  dt,
  size = "small",
  cellSelection = false,
  onCellClick,
  selectionMode,
  selection,
  onSelectionChange,
  dataKey,
  scrollable = false,
  paginator = true,
  formatFileName = true,
  rowGroupMode,
  groupRowsBy,
  sortField,
  searchResultHeader,
  onRowClick, // Add this prop
}) => {
  const today = new Date();
  const formatDate = formatDateYYYYMMDD(today);

  // Custom sort icon function
  const customSortIcon = (options) => {
    const iconClassName = "text-secondary-purpleGray ml-2";

    if (options.sorted) {
      if (options.sortOrder === 1) {
        return <i className={`pi pi-sort-amount-up ${iconClassName}`} />;
      } else if (options.sortOrder === -1) {
        return <i className={`pi pi-sort-amount-down ${iconClassName}`} />;
      }
    }

    return <i className={`pi pi-sort-alt ${iconClassName}`} />;
  };

  // Custom filter icon function
  const customFilterIcon = (options) => {
    const iconClassName = "text-secondary-secondaryGray";

    if (options.filterApplied) {
      return <i className={`pi pi-filter-fill ${iconClassName}`} />;
    }

    return <i className={`pi pi-filter ${iconClassName}`} />;
  };

  const globalPaginatorTemplate = {
    layout:
      "RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",

    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];
      return (
        <div className="flex items-center">
          <span
            className="mr-3 flex items-center"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Rows per page:
            <Dropdown
              value={options.value}
              options={dropdownOptions}
              onChange={options.onChange}
            />
          </span>
        </div>
      );
    },
  };

  return (
    <div className={parentClassName}>
      <DataTable
        showGridlines
        value={items}
        size={size}
        stripedRows
        paginator={paginator}
        ref={dt}
        exportFilename={
          formatFileName !== false
            ? `${exportFilename}`
            : `${exportFilename}-${formatDate}`
        }
        multiple
        removableSort
        className={`${tableClassName} font-montserrat`}
        sortMode="multiple"
        emptyMessage={emptyMessage}
        rows={10}
        header={searchResultHeader}
        headerColumnGroup={headerColumnGroup}
        rowHover={false}
        paginatorTemplate={globalPaginatorTemplate}
        sortIcon={customSortIcon}
        filterIcon={customFilterIcon}
        footer={footer}
        cellSelection={cellSelection}
        selectionMode={selectionMode}
        onCellClick={onCellClick}
        selection={selection}
        onSelectionChange={onSelectionChange}
        dataKey={dataKey}
        scrollable={scrollable}
        scrollHeight={scrollable ? "400px" : ""}
        rowGroupMode={rowGroupMode}
        groupRowsBy={groupRowsBy}
        sortField={sortField}
      >
        {children}
      </DataTable>
    </div>
  );
};

export default NewDataTable;
